"use client";
import { ReactNode } from "react";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./context/AuthContext";
import { RestaurantProvider } from "./context/RestaurantContext";

export default function Providers({ children }: { children: ReactNode }) {
    return (
        <AuthProvider>
            <RestaurantProvider>
                {children}
                <Toaster
                    position="top-right"
                    toastOptions={{
                        duration: 4000,
                        style: {
                            background: '#18181b',
                            color: '#fff',
                            border: '1px solid #27272a',
                        },
                        success: {
                            iconTheme: {
                                primary: '#10b981',
                                secondary: '#fff',
                            },
                        },
                        error: {
                            iconTheme: {
                                primary: '#ef4444',
                                secondary: '#fff',
                            },
                        },
                    }}
                />
            </RestaurantProvider>
        </AuthProvider>
    );
}